export default __webpack_public_path__ + "static/media/aboutus.83b614cf.jpg";